import React, { useCallback } from 'react';
import classNames from 'classnames';
import useNodeVariables from 'components/FileAccessSelector/hooks/useNodeVariables';
import { Checkbox } from 'ncoded-component-library';
import {
  getIsChecked,
  getNewCheckboxState,
} from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/DataRoomDocumentDrawers/ManageFileAccess/utils';
import { NodeRowProps } from 'components/FileAccessSelector/types';

import './FileAccessCheckboxes.styles.scss';

type FileAccessCheckboxesProps = {
  className?: string;
  id: string;
} & NodeRowProps;

const FileAccessCheckboxes: React.FC<FileAccessCheckboxesProps> = (props) => {
  const {
    className,
    id,
    node,
    hasDownload,
    checkedFilesIds,
    checkedDownloadIds,
    onChange,
    checkIfNodeIsDisabled,
  } = props;

  const classes = classNames('file-access-checkboxes', className);

  const {
    currState: viewState,
    checked: viewChecked,
    disabled: viewDisabled,
    nodeClass: viewClass,
  } = useNodeVariables({
    node,
    checkedFilesIds,
    checkIfNodeIsDisabled,
  });

  const {
    currState: downloadState,
    checked: downloadChecked,
    disabled: downloadDisabled,
    nodeClass: downloadClass,
  } = useNodeVariables({
    node,
    checkedFilesIds: checkedDownloadIds,
    checkIfNodeIsDisabled,
  });

  const nextViewChecked = getIsChecked(getNewCheckboxState(viewState));
  const nextDownloadChecked = getIsChecked(getNewCheckboxState(downloadState));

  const onCheckboxChange = useCallback(
    (enable?: boolean, enableDownload?: boolean) =>
      onChange({
        dataRoomNodeId: node._id,
        enable,
        enableDownload,
      }),
    [node._id, onChange],
  );

  return (
    <div className={classes} id={id}>
      <div className={viewClass} onClick={(e) => e.stopPropagation()}>
        <Checkbox
          key={viewState}
          checked={viewChecked}
          disabled={viewDisabled}
          className={classNames(viewClass, 'access-checkbox')}
          onChange={() => onCheckboxChange(nextViewChecked, false)}
        />
      </div>

      {hasDownload && (
        <div className={downloadClass} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={downloadChecked}
            disabled={downloadDisabled}
            className={classNames(downloadClass, 'access-checkbox')}
            onChange={() => onCheckboxChange(true, nextDownloadChecked)}
          />
        </div>
      )}
    </div>
  );
};

export default FileAccessCheckboxes;
